import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=a5c8ef50&scoped=true"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"
import style0 from "./stats.vue?vue&type=style&index=0&id=a5c8ef50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c8ef50",
  null
  
)

export default component.exports